module.exports = __webpack_public_path__ + "static/media/razorpay2.fcfab237.png";